import React from 'react';
import { Waves, Trees, Car, Wifi, UtensilsCrossed, Sparkles } from 'lucide-react';
import { facilities } from '../mockData';
import { useSEO } from '../hooks/useSEO';
import facilitiesImage from '../assets/images/facilities.webp';

const FacilitiesPage = () => {
  useSEO({
    title: 'Facilities | OlivOak Villa',
    description: 'Discover world-class facilities at OlivOak Villa, Harare. Swimming pool, gardens, parking, Wi-Fi, dining, and more for an exceptional stay.'
  });

  const iconMap = {
    Waves,
    Trees,
    Car,
    Wifi,
    UtensilsCrossed,
    Sparkles
  };

  return (
    <div style={{ backgroundColor: 'var(--bg-primary)', minHeight: '100vh', paddingTop: '80px' }}>
      <section
        className="relative py-24"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('${facilitiesImage}')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="container text-center">
          <h1 className="hero-large mb-4" style={{ color: '#ffffff' }}>
            Our Facilities
          </h1>
          <p className="body-large" style={{ color: '#f0f0f0', maxWidth: '600px', margin: '0 auto' }}>
            Experience world-class amenities designed for your comfort
          </p>
        </div>
      </section>

      <section className="section-padding">
        <div className="container">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
            {facilities.map((facility, index) => {
              const IconComponent = iconMap[facility.icon];
              return (
                <div
                  key={facility.name}
                  className="text-center p-8 hover-lift"
                  style={{
                    backgroundColor: index % 2 === 0 ? 'var(--bg-secondary)' : 'var(--bg-primary)',
                    border: '1px solid var(--border-light)'
                  }}
                >
                  <div
                    className="inline-flex items-center justify-center w-20 h-20 mb-6"
                    style={{
                      border: '1px solid var(--border-medium)',
                      color: 'var(--text-primary)'
                    }}
                  >
                    {IconComponent && <IconComponent size={36} />}
                  </div>
                  <h3 className="heading-2 mb-4">{facility.name}</h3>
                  <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                    {facility.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="section-padding" style={{ backgroundColor: 'var(--bg-secondary)' }}>
        <div className="container max-w-4xl text-center">
          <h2 className="heading-1 mb-6">Additional Services</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-left">
            <div
              className="p-6"
              style={{
                backgroundColor: 'var(--bg-primary)',
                border: '1px solid var(--border-light)'
              }}
            >
              <h3 className="heading-3 mb-3">Concierge Service</h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                24/7 assistance for tours, transport, and local recommendations
              </p>
            </div>
            
            <div
              className="p-6"
              style={{
                backgroundColor: 'var(--bg-primary)',
                border: '1px solid var(--border-light)'
              }}
            >
              <h3 className="heading-3 mb-3">Laundry Service</h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                Same-day laundry and dry cleaning services available
              </p>
            </div>
            <div
              className="p-6"
              style={{
                backgroundColor: 'var(--bg-primary)',
                border: '1px solid var(--border-light)'
              }}
            >
              <h3 className="heading-3 mb-3">Airport Transfer</h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                Pickup and drop-off service to the airport
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FacilitiesPage;
